/* ============================================================
   TreadAuto 导航自适应 ta-nav-responsive.js
   ------------------------------------------------------------
   职责：仅切换 class，不生成链接、不请求数据。
   服务端已渲染的 125 条 collection 链接始终在 DOM 里，
   JS 失效时 CSS 的 :not(.js-ready) 降级分支保证全部可见可点。
   ============================================================ */
(function () {
  'use strict';

  var MOBILE_MAX = 1180;           // 与 CSS 断点一致
  var root = document.querySelector('.ta-nav');
  if (!root) return;

  var hnav = root.querySelector('.hnav');
  if (!hnav) return;

  /* ---------- 1. 注入抽屉控件（CSS 在桌面隐藏它们） ---------- */
  var ICON = {
    burger: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 6h18M3 12h18M3 18h18"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>',
    chev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg>'
  };

  // 汉堡：放在图标组之后
  var burger = document.createElement('button');
  burger.className = 'navburger';
  burger.type = 'button';
  burger.setAttribute('aria-label', 'Open menu');
  burger.setAttribute('aria-expanded', 'false');
  burger.setAttribute('aria-controls', 'ta-nav-drawer');
  burger.innerHTML = ICON.burger;
  var icoGroup = root.querySelector('.mast-ico');
  if (icoGroup) icoGroup.appendChild(burger);

  // 给 hnav 一个 id 供 aria-controls 指向
  hnav.id = 'ta-nav-drawer';
  hnav.setAttribute('aria-label', 'Main navigation');

  // 遮罩
  var scrim = document.createElement('div');
  scrim.className = 'dscrim';
  root.appendChild(scrim);

  // 抽屉头部：标题 + 关闭 + 搜索（搜索框从顶条克隆，保持 action/name 一致）
  var head = document.createElement('div');
  head.className = 'dpanel-head';
  var topRow = document.createElement('div');
  topRow.className = 'dpanel-top';
  topRow.innerHTML = '<span>Menu</span>';
  var closeBtn = document.createElement('button');
  closeBtn.className = 'dclose';
  closeBtn.type = 'button';
  closeBtn.setAttribute('aria-label', 'Close menu');
  closeBtn.innerHTML = ICON.close;
  topRow.appendChild(closeBtn);
  head.appendChild(topRow);

  var srcSearch = root.querySelector('.mast > .wrap > .search');
  if (srcSearch) head.appendChild(srcSearch.cloneNode(true));
  hnav.insertBefore(head, hnav.firstChild);

  /* ---------- 2. 每个一级项加展开按钮 ---------- */
  var items = [].slice.call(hnav.querySelectorAll('.pitem'));
  items.forEach(function (pi, i) {
    var mega = pi.querySelector('.mega');
    if (!mega) return;                       // 无子菜单的一级项不加按钮
    var top = pi.querySelector('.top');
    var label = top ? top.textContent.trim() : 'Section ' + (i + 1);

    var panelId = 'ta-nav-panel-' + i;
    mega.id = panelId;

    var btn = document.createElement('button');
    btn.className = 'acc-btn';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Expand ' + label);
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', panelId);
    btn.innerHTML = ICON.chev;
    pi.appendChild(btn);

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleAccordion(pi, btn);
    });
  });

  function toggleAccordion(pi, btn) {
    var open = pi.classList.contains('is-open');
    // 手风琴：一次只开一个，避免抽屉过长
    items.forEach(function (o) {
      if (o === pi) return;
      o.classList.remove('is-open');
      var b = o.querySelector('.acc-btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    pi.classList.toggle('is-open', !open);
    btn.setAttribute('aria-expanded', String(!open));
  }

  /* ---------- 3. 抽屉开关 ---------- */
  var lastFocus = null;

  function openDrawer() {
    lastFocus = document.activeElement;
    root.classList.add('is-drawer-open');
    document.documentElement.classList.add('ta-nav-locked');
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', 'Close menu');
    closeBtn.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeDrawer() {
    root.classList.remove('is-drawer-open');
    document.documentElement.classList.remove('ta-nav-locked');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Open menu');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    // 焦点圈在抽屉内
    var f = hnav.querySelectorAll('a[href], button, input, select, textarea');
    var list = [].filter.call(f, function (el) {
      return el.offsetParent !== null && !el.disabled;
    });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  burger.addEventListener('click', function () {
    root.classList.contains('is-drawer-open') ? closeDrawer() : openDrawer();
  });
  closeBtn.addEventListener('click', closeDrawer);
  scrim.addEventListener('click', closeDrawer);

  /* ---------- 4. 跨断点清理状态 ---------- */
  // 从窄屏拖宽时，残留的 is-drawer-open / is-open 会让桌面菜单错乱
  var mq = window.matchMedia('(min-width: ' + (MOBILE_MAX + 1) + 'px)');
  function onBreakpoint(e) {
    if (e.matches) {
      root.classList.remove('is-drawer-open');
      document.documentElement.classList.remove('ta-nav-locked');
      burger.setAttribute('aria-expanded', 'false');
      items.forEach(function (o) {
        o.classList.remove('is-open');
        var b = o.querySelector('.acc-btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      document.removeEventListener('keydown', onKeydown);
    }
  }
  mq.addEventListener ? mq.addEventListener('change', onBreakpoint)
                      : mq.addListener(onBreakpoint);

  /* 手机上账户图标会隐藏，抽屉底部保留账户和购物车入口 */
  var dfoot = document.createElement('div');
  dfoot.className = 'dfoot';
  [
    { sel: '.mast-ico .ico-btn.acct', label: 'Account' },
    { sel: '.mast-ico .ico-btn[aria-label="Cart"]', label: 'Cart' }
  ].forEach(function (item) {
    var src = root.querySelector(item.sel);
    if (!src) return;
    var a = document.createElement('a');
    a.href = src.getAttribute('href');
    a.innerHTML = src.querySelector('svg') ? src.querySelector('svg').outerHTML : '';
    var t = document.createElement('span');
    t.textContent = item.label;
    a.appendChild(t);
    dfoot.appendChild(a);
  });
  hnav.appendChild(dfoot);

  /* ---------- 5. 标记 JS 可用，启用抽屉样式 ---------- */
  root.classList.add('js-ready');
})();
